import { Component } from '@angular/core';
import { ModalComponent } from '../../../lib/services/modal.service';
import { take } from 'rxjs/operators';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { UnitService } from '../../services/unit';
import { LoadUnitUsers } from '../../actions/unit';
import { Store } from '@ngrx/store';
import * as fromUnits from '../../reducers';
import { MatSnackBar } from '@angular/material/snack-bar';
import { FormControl } from '@angular/forms';

const allRoles = [
  { value: 1, viewValue: 'Admin' },
  { value: 2, viewValue: 'Recruiter' },
  { value: 3, viewValue: 'Viewer' },
];

@Component({
  selector: 'mj-unit-add-users',
  templateUrl: './unit-add-users.component.html',
  styleUrls: ['./unit-add-users.component.scss'],
})
export class UnitAddUsersComponent extends ModalComponent {
  unit;
  roles = allRoles;
  form: FormGroup;
  users$;
  loading: boolean;

  constructor(
    private fb: FormBuilder,
    private unitService: UnitService,
    private store: Store<fromUnits.State>,
    private snackbar: MatSnackBar
  ) {
    super();
    this.form = this.fb.group({
      users: this.fb.array([this.createFormGroup()]),
    });

    this.data.pipe(take(1)).subscribe(data => {
      this.unit = data['unit'];
      this.users$ = data['users$'];
    });
  }

  public trimValidator(control: FormControl) {
    const isWhitespace = (control.value || '').trim().length === 0;
    return isWhitespace ? { whitespace: true } : null;
  }

  createFormGroup(): FormGroup {
    return this.fb.group({
      email: ['', [Validators.required, Validators.email, this.trimValidator]],
      name: ['', [Validators.required, this.trimValidator]],
      surname: ['', [Validators.required, this.trimValidator]],
      role: ['', [Validators.required]],
    });
  }

  addNewUser() {
    this.usersArray.push(this.createFormGroup());
  }

  save() {
    this.loading = true;
    const newUser = {
      unit: {
        id: this.unit.id,
      },
      user: {
        username: this.usersArray.controls[0].get('email').value,
        first_name: this.usersArray.controls[0].get('name').value,
        last_name: this.usersArray.controls[0].get('surname').value,
      },
      role: this.usersArray.controls[0].get('role').value,
      has_seen_intro: false,
      has_accepted_invitation: false,
    };

    this.users$.pipe(take(1)).subscribe(users => {
      const userExists = users.find(
        user => user.user.username === newUser.user.username
      );
      if (userExists) {
        this.loading = false;
        return this.snackbar.open('Invitation is already sent', null, {
          duration: 3000,
        });
      }

      this.unitService
        .postUsers(this.unit.id, newUser)
        .pipe(take(1))
        .subscribe(
          () => {
            this.loading = false;

            this.store.dispatch(new LoadUnitUsers({ id: this.unit.id }));
            this.resolve.next(null);
          },
          () => {
            this.loading = false;

            this.snackbar.open('Something went wrong', null, {
              duration: 3000,
            });
          }
        );
    });
  }

  cancel() {
    this.resolve.next(null);
  }

  removeUser(i) {
    this.usersArray.controls.splice(i, 1);
  }

  get usersArray() {
    return this.form.get('users') as FormArray;
  }
}
